import { ImageObserver } from "components/ImageObserver/ImageObserver"
import cls from "./AboutPage.module.scss"
import { MouseEvent, SyntheticEvent, useState } from "react"

export const AboutPage = () => {
    const [observerOpen, setObserverOpen] = useState(false)
    const [currentImage, setCurrentImage] = useState<string | undefined>('')

    const onOpenObserver = (e: MouseEvent<HTMLImageElement>) => {
        // const target = e.target as HTMLImageElement
        const src: any = e.currentTarget.getAttribute("src")
        setObserverOpen(true)
        setCurrentImage(src)
        document.body.style.overflow = "hidden"
    }

    const onCloseObserver = () => {
        setObserverOpen(false)
        setCurrentImage('')
        document.body.style.overflow = "auto"
    }

    return (
        <div className={cls.aboutPage}>
            {observerOpen ? <ImageObserver image={currentImage} onClose={onCloseObserver} /> : null}
            <div className={cls.line}></div>
            <div className={cls.container}>
                <div className={cls.paragraph}>
                    <b>Я - frontend разработчик с фокусом на React.</b> Мой стек технологий включает в себя HTML, CSS, JavaScript, React, Git, Firebase
                    и другие современные инструменты для разработки в web сфере. Я имею опыт в создании веб-приложений, которые отвечают потребностям
                    пользователей и бизнеса.
                </div>
                <div className={cls.item}>
                    <div className={cls.itemText}>
                        <div className={cls.itemTitle}>
                            <div className={cls.horizontalLine}></div>
                            TagLife (2022-2024)
                        </div>
                        Разработка в команде кроссплатформенного PWA-приложения, цель которого поднимать самооценку
                        <div style={{ marginTop: '20px' }}>
                            <b>Стек:</b> React, Redux Toolkit, framer-motion, react-spring, react-swipeable, Google Firebase, Nginx, Storybook, Husky, CI/CD, Jest
                        </div>
                        <div style={{ marginTop: '20px' }}><b>Задачи:</b></div>
                        <ul>
                            <li>Разработка MVP-версии приложения для тестирования гипотез на целевой аудитории</li>
                            <li>Соблюдение архитектурных стилей FSD для будущей поддержки</li>
                            <li>Разработка веб-версии продукта (профиль, лента, друзья, предложка) в качестве PWA приложения</li>
                            <li>Разработка гибкой адаптивной верстки под большинство смартфонов</li>
                            <li>Создание и подъем серверов для приложения, конфигурирование Nginx</li>
                            <li>Реализовал интерактивные модули под различные сценарии установки приложения</li>
                        </ul>
                        <div style={{ marginTop: '20px' }}><b>Личные достижения:</b></div>
                        <ul>
                            <li>Перевел проект из стадии MVP в полноценную социальную сеть</li>
                            <li>Предложил и реализовал фичу в проекте, которая подняла возврат пользователей на 30%</li>
                            <li>Предложил и реализовал админ-панель приложения, что позволило снизить контентные трудозатраты</li>
                        </ul>
                    </div>
                    <iframe
                        className={cls.youtube}
                        src="https://www.youtube.com/embed/lyluBc5FITM?si=S8JCdoOwD98o_6U4"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen={true}
                    >
                    </iframe>
                </div>
                <div className={cls.item}>
                    <div className={cls.itemText}>
                        <div className={cls.itemTitle}>
                            <div className={cls.horizontalLine}></div>
                            Okko.tv (2021-2022)
                        </div>
                        Middle frontend dev.
                        <div style={{ marginTop: '20px' }}>
                            <b>Стек:</b> React, TypeScript, Redux, RTK Query, react-hook-form, storybook
                        </div>
                        <div style={{ marginTop: '20px' }}><b>Задачи:</b></div>
                        <ul>
                            <li>Разработка rail (карусель) одной из страниц главного экрана</li>
                            <li>Разработка настроек профиля, в частности мультипрофиля (детский, взрослый профили)</li>
                            <li>Участие в процессах код-ревью</li>
                            <li>Сотрудничество с дизайнерами и другими разработчиками для реализации новых функций и улучшения общего пользовательского опыта</li>
                            <li>Рефакторинг кода (перевод из классовых компонентов в функциональные)</li>
                            <li>Написание unit тестов на jest + react-testing-library</li>
                            <li>Принимал участие в инфраструктурных задачах настройки ci/cd pipeline</li>
                        </ul>
                        <div style={{ marginTop: '20px' }}><b>Личные достижения:</b></div>
                        <ul>
                            <li>Полностью переработал страницу настроек профиля, добавив варианты подписки, подписки на рассылку уведомлений и оплату услуг</li>
                            <li>Реализовал удобную форму оплаты услуг через профиль</li>
                        </ul>
                    </div>
                </div>
                <div className={cls.item}>
                    <div className={cls.itemText}>
                        <div className={cls.itemTitle}>
                            <div className={cls.horizontalLine}></div>
                            Работа в АФТ-Энерго (2019-2021)
                        </div>
                        Frontend dev.
                        <div style={{ marginTop: '20px' }}>
                            <b>Стек:</b> React, Javascript, Redux, formik, Axios, Formik
                        </div>
                        <div style={{ marginTop: '20px' }}><b>Задачи:</b></div>
                        <ul>
                            <li>Перевод сайта компании на функциональные компоненты React с jQuery</li>
                            <li>Создание интерфейса расчетных систем для внутреннего пользования и решения бизнес задач</li>
                            <li>Реализация системы поиска по продуктам компании</li>
                            <li>Работа с формами, защита от ботов, валидация форм через Formik, Yup</li>
                            <li>Настройка webpack конфигурации</li>
                            <li>Деплой приложения через ci/cd workflow с помощью jenkins</li>
                        </ul>
                        <div style={{ marginTop: '20px' }}><b>Личные достижения:</b></div>
                        <ul>
                            <li>Оптимизировал процесс сборки сайта с использованием Webpack, что уменьшило время сборки</li>
                            <li>Повысил оптимизацию и общее качество кода в легаси-проекте</li>
                            <li>Уменьшил количество отказов и скорость загрузки сайта компании в 2 раза</li>
                        </ul>
                    </div>
                </div>
                <div className={cls.item}>
                    <div className={cls.itemText}>
                        <div className={cls.itemTitle}>
                            <div className={cls.horizontalLine}></div>
                            Университет (2015-2021)
                        </div>
                        НИУ МЭИ
                        <ul>
                            <li>Закончил бакалавриат по направлению "Теплоэнергетика и Теплотехника" кафедры <b>тепловых электрических станций</b> в 2019 году.</li>
                            <li>Закончил магистратуру кафедры <b>информационных технологий наукоёмких отраслей</b> в 2021 году <b>с отличием.</b></li>
                            <li>В магистратуре был <b>автором патентов, публикаций, статей.</b> Получал повышенную государственную стипендию (ПГАС) и стипендию правительства.</li>
                            <li>Выступал на конференциях и участвовал в разработке различных инновационных систем в сфере энергетики в рамках различных конкурсов и грантов.</li>
                            <li>В ходе обучения познакомился с программированием и там же начал изучать его углубленно.</li>
                        </ul>
                    </div>
                    <div className={cls.itemImages}>
                        <img onClick={onOpenObserver} src="images/1.png" className={cls.image} alt={'img'}></img>
                        <img onClick={onOpenObserver} src="images/2.jpg" className={cls.image} alt={'img'}></img>
                        <img onClick={onOpenObserver} src="images/3.jpg" className={cls.image} alt={'img'}></img>
                        <img onClick={onOpenObserver} src="images/4.jpg" className={cls.image} alt={'img'}></img>
                    </div>
                </div>
                <div className={cls.item}>
                    <div className={cls.itemText}>
                        <div className={cls.itemTitle}>Разработка приложения для университета</div>
                        Занимался разработкой расчетного приложения в команде студентов-инженеров,
                        целью которого является определение по известной паре параметров свойств воды и водяного пара.
                        <div style={{ marginTop: '20px' }}><b>Личные цели и задачи:</b></div>
                        <ul>
                            <li>Разработка программы для расчета с функционалом получения свойств воды и пара в R studio</li>
                            <li>Соединение своей расчетной программы с другими для создания единого расчетной системы</li>
                            <li>Разработка интерфейса программы для использования на внутреннем сайте университета</li>
                            <li>Разработка презентации в виде приложения Unity</li>
                        </ul>
                    </div>
                    <div className={cls.itemImages}>
                        <img onClick={onOpenObserver} src="images/5.png" className={cls.image} alt={'img'}></img>
                        <img onClick={onOpenObserver} src="images/6.png" className={cls.image} alt={'img'}></img>
                        <img onClick={onOpenObserver} src="images/7.png" className={cls.image} alt={'img'}></img>
                        <img onClick={onOpenObserver} src="images/8.png" className={cls.image} alt={'img'}></img>
                    </div>
                </div>
            </div>
        </div>
    )
}